module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921095651_T.85c8da06.jpg";